import { enUS, it } from 'date-fns/locale'

export const locales = {
  en: enUS,
  it,
}
